import type { Hit } from '@algolia/client-search'
import type { BaseHit } from 'instantsearch.js/es/types'

import { indexName as defaultIndexName } from '../lib/algolia'

export type GetInsightsStoredInfoProps = {
  queryID: string
  indexName: string
  position: number
  objectID: string
  price: number
  currency: string
  quantity: number
}

export interface InsightInfoHit extends Hit<BaseHit> {
  regionalAttributes?: {
    [key: string]: {
      promotionalPrice: number
    }
  }
}

export const getInsightsStoredInfo = () =>
  JSON.parse(
    localStorage.getItem('__algoliaInsights__') ?? 'null'
  ) as GetInsightsStoredInfoProps | null

export const setInsightsInfo = (
  hit: InsightInfoHit,
  region: string,
  indexName?: string,
  priceOverride?: number
) => {
  const price =
    priceOverride ?? hit.regionalAttributes?.[region]?.promotionalPrice ?? 0

  const hitObj = {
    indexName: indexName ?? defaultIndexName,
    objectID: hit.objectID,
    queryID: hit.__queryID,
    position: hit.__position,
    price,
    currency: 'BRL',
    quantity: 1
  }

  localStorage.setItem('__algoliaInsights__', JSON.stringify(hitObj))
}
